import { render, staticRenderFns } from "./AssignServicesToAdmins.vue?vue&type=template&id=758d43f8&"
import script from "./AssignServicesToAdmins.vue?vue&type=script&lang=ts&"
export * from "./AssignServicesToAdmins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports